export default __webpack_public_path__ + "static/media/EmojiLionIcon.1ac1a257.svg";